module.exports = "./img/6989b456214aa706239aaad2419a8830.png";